import { computed, ref } from 'vue'

export const useInput = (value = '', { validate = () => {} }) => {
  const inputValue = ref(value)
  const isValidCheckOn = ref(false)

  const isValid = computed(() => {
    if (!validate) {
      return true
    }
    return validate(inputValue.value)
  })

  const isErrorShow = computed(() => {
    return !isValid.value && isValidCheckOn.value
  })

  const onBlur = () => {
    isValidCheckOn.value = inputValue.value !== ''
  }

  return {
    value: inputValue,
    isValid,
    isValidCheckOn,
    isErrorShow,
    onBlur,
  }
}
